import React, { FunctionComponent } from 'react';
import Icon, { IconName, IconSize } from 'components/icon/icon';
import FacebookIcon from 'components/social-links/facebook.svg';
import InstagramIcon from 'components/social-links/instagram.svg';
import PinterestIcon from 'components/social-links/pinterest.svg';
import SnapchatIcon from 'components/social-links/snapchat.svg';
import LinkedInIcon from 'components/social-links/linkedin.svg';
import YouTubeIcon from 'components/social-links/youtube.svg';
import TikTokIcon from 'components/social-links/tiktok.svg';

export enum SocialNetworks {
    FACEBOOK = 'facebook',
    INSTAGRAM = 'instagram',
    TWITTER = 'twitter',
    PINTEREST = 'pinterest',
    SNAPCHAT = 'snapchat',
    LINKEDIN = 'linkedin',
    YOUTUBE = 'youtube',
    TIKTOK = 'tiktok',
}

export type SocialLink = {
    type: SocialNetworks;
    url: string;
};

const SOCIAL_NETWORK_TO_ICON: {
    [key in SocialNetworks]?: IconName;
} = {
    [SocialNetworks.TWITTER]: 'generic-twitter' as IconName,
};

export type SocialLinksProps = {
    socialLinks: SocialLink[];
};

const getSocialLinkIcon = (socialNetwork: SocialNetworks) => {
    if (socialNetwork === SocialNetworks.FACEBOOK) {
        return <FacebookIcon />;
    } else if (socialNetwork === SocialNetworks.PINTEREST) {
        return <PinterestIcon />;
    } else if (socialNetwork === SocialNetworks.SNAPCHAT) {
        return <SnapchatIcon />;
    } else if (socialNetwork === SocialNetworks.INSTAGRAM) {
        return <InstagramIcon />;
    } else if (socialNetwork === SocialNetworks.LINKEDIN) {
        return <LinkedInIcon />;
    } else if (socialNetwork === SocialNetworks.YOUTUBE) {
        return <YouTubeIcon />;
    } else if (socialNetwork === SocialNetworks.TIKTOK) {
        return <TikTokIcon />;
    }
    return <Icon name={SOCIAL_NETWORK_TO_ICON[socialNetwork]} size={IconSize.STRETCH} />;
};

const SocialLinks: FunctionComponent<SocialLinksProps> = ({ socialLinks }) => {
    return socialLinks.length > 0 ? (
        <ul className="social-links">
            {socialLinks.map((socialLink) => {
                const socialIcon = getSocialLinkIcon(socialLink.type);

                return (
                    <li key={socialLink.type} className="social-links__item">
                        <a
                            className="social-links__link"
                            href={socialLink.url}
                            target="_blank"
                            rel="noreferrer"
                        >
                            {socialIcon}
                        </a>
                    </li>
                );
            })}
        </ul>
    ) : null;
};

export default SocialLinks;
